import { tickerItems } from "@/mocks/site";

export default function Ticker() {
  const items = [...tickerItems, ...tickerItems];
  return (
    <section className="border-y border-background-200 bg-background-100/70" aria-label="今日热榜">
      <div className="mx-auto flex max-w-[1440px] items-center gap-4 overflow-hidden px-4 py-3 md:px-8">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
          <i className="ri-fire-line text-sm" />
          今日热榜
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track whitespace-nowrap">
            {items.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="mx-4 inline-flex items-center gap-2 text-sm text-foreground-700"
              >
                <i className="ri-bookmark-3-line text-primary-500" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}